import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBalloon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2199 15.9694L16.4492 16.2088C15.5408 17.0789 15.2068 17.9624 15.7045 18.9355C16.3175 20.1341 16.1926 20.8891 15.3624 21.8816L15.1081 21.6689C15.857 20.7737 15.9585 20.1601 15.4094 19.0864C14.8304 17.9543 15.2179 16.9292 16.2199 15.9694Z",
			fill: "#111827",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7983 15.5487C14.7983 15.5487 13.5597 16.0429 14.2411 16.3014C14.9225 16.5599 18.1431 16.3356 17.8677 15.8562C17.5923 15.3768 16.9317 15.2868 16.9317 15.2868C16.9317 15.2868 27.6039 9.61419 20.6032 2.86097C13.5128 -3.97876 2.4508 10.2218 14.7983 15.5487Z",
			fill: "#111827",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7766 17.7741C12.1076 18.1199 11.4334 18.3763 11.0977 18.3698C10.2234 18.3527 11.1706 17.1528 11.1706 17.1528C-5.10072 16.0236 -0.257749 -3.38243 10.0644 1.93544C17.8477 5.94526 13.1945 15.8385 13.1945 15.8385C13.1945 15.8385 13.9352 15.6499 14.5382 16.1354C14.849 16.3857 14.1579 16.9759 13.2953 17.487C14.7714 18.5007 15.1627 18.991 15.2736 19.9998C15.3097 20.3284 15.2938 20.5935 15.2259 21.1903C15.1034 22.2672 15.1499 22.6898 15.5584 23.1072L15.1803 23.4773C14.6201 22.905 14.5602 22.3606 14.7001 21.1305C14.7634 20.5737 14.7779 20.3334 14.7476 20.0576C14.6536 19.2024 14.3114 18.8075 12.7766 17.7741Z",
			fill: "#111827"
		})
	]
});
const ForwardRef = forwardRef(SvgBalloon);
export default ForwardRef;
